import {FC} from 'react';
import {createPortal} from 'react-dom';
import {CSSTransition, TransitionGroup} from 'react-transition-group';

import NotificationItem from './NotificationItem';
import {InternalNotification} from '../types';
import s from '../styles.module.scss';

interface NotificationListProps {
  notifications: InternalNotification[];
  onCloseNotification: (id: string) => void;
}

const NotificationList: FC<NotificationListProps> = ({notifications, onCloseNotification}) =>
  createPortal(
    <TransitionGroup className={s['notification-list']}>
      {notifications.map((notification) => (
        <CSSTransition
          key={notification.id}
          nodeRef={notification.ref}
          timeout={300}
          classNames={{
            exit: s['notification-exit'],
            exitActive: s['notification-exit-active'],
          }}
        >
          <NotificationItem
            {...notification}
            ref={notification.ref}
            closeNotification={() => onCloseNotification(notification.id)}
          />
        </CSSTransition>
      ))}
    </TransitionGroup>,
    document.body
  );

export default NotificationList;
